// At one point we started implementing conditional associations with autosave and
// made the system generic using this strategy pattern. But that project was cancelled
// so now there is only one strategy, PROPERTY.
// We use a conditional type here (extends any ? {...} : never) to take advantage of
// "Distributive Conditional Types". With this, typescript distributes the union
// essentially going from AutosaveRequest<TStrategyType> to things like, for example,
// AutosaveRequest<'PROPERTY'> | AutosaveRequest<'ASSOCIATION'>. This allows the
//  type system to effectively discriminate based on the 'type' field here.
// https://www.typescriptlang.org/docs/handbook/2/conditional-types.html#distributive-conditional-types
export function groupByStrategyType(items) {
  return {
    PROPERTY: items.filter(item => item.data.request.type === 'PROPERTY')
  };
}
export const isPropertyAutosaveRequest = request => {
  return request.type === 'PROPERTY';
};